export const GET_EXPLORE_DATA_REQUEST = 'GET_EXPLORE_DATA_REQUEST';
export const GET_EXPLORE_DATA_SUCCESS = 'GET_EXPLORE_DATA_SUCCESS';
export const GET_EXPLORE_DATA_FAILURE = 'GET_EXPLORE_DATA_FAILURE';

export const RESET_EXPLORE_DATA = 'RESET_EXPLORE_DATA';
export const UPDATE_EXPLORE_TEXT = 'UPDATE_EXPLORE_TEXT';